export default __webpack_public_path__ + "static/media/banner-ar_en.804dd893.png";